import React from "react";
import { useRef } from "react";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
    
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "../styles/styles.css";

gsap.registerPlugin(useGSAP,ScrollTrigger);

const cardsData = [
    {
        title: "Octopod",
        language: "React.js | Tailwind CSS",
        description: `I designed and built the entire framework using React.js. OctoPod helps take the guesswork out of studying by generating custom practice questions directly from your notes. 
                        This website gives you feedback on your performance, easily showing exactly what you need to review more! It includes an integrated AI chatbot tutor to make the learning process interactive.
                        Search Octopod Introduction on YouTube to see how it works!`,
        img: "/Octopod.webp",
        imgFallback: "/Octopod.png",
        link: "https://github.com/Je-re-me/OctoPod"
    },
    {
        title: "4x4 Sudoku",
        language: "Java | JSON",   
        description: `I developed a complete, self-generating Sudoku game using Java. A key feature is its ability to generate puzzles where players can customize the difficulty by choosing the number of blank spaces in the puzzle.
                        To ensure a smooth experience, I used the JSON library to automatically save player progress and puzzle history. This allows users to easily track their past attempts and even load unfinished games after closing and reopening the application.`,
        img: "/Sudoku.webp",
        imgFallback: "/Sudoku.png",
        link: "https://github.com/Je-re-me/SudokuGame"
    },
    {
        title: "Airbnb Rating Predictor",
        language: "Python | Scikit-learn | Pandas",
        description: `I built a machine learning model to predict the amount of ratings per month a Airbnb listing a post will get based on various features such as location, price, and amenities.
                        I used Python with libraries like Scikit-learn and Pandas for data processing and model training.`,
        img: "/Airbnb.webp",
        imgFallback: "/Airbnb.png",
        link: "https://github.com/Je-re-me/Airbnb_Price_Prediction_NYC"
    }
];

export default function StackedCards() {
    const containerRef = useRef(null);

    useGSAP(() => {
        const cards = gsap.utils.toArray(".card");

        gsap.set(".img-wrapper img", {
            clipPath: "polygon(0 0, 0 100%, 0 100%, 0 0)",
            autoAlpha: 0,
        });

        gsap.set(".card-content h1, .card-content p", {
            y: 0,
            autoAlpha: 0,
        });

        cards.forEach((card, i) => {
            const img = card.querySelector("img");
            const textEls = card.querySelectorAll(".card-content h1, .card-content p");

            gsap.to(card, {
                scale: 0.8 + 0.2 * (i / (cards.length - 1)),
                ease: "none",
                scrollTrigger: {
                    trigger: card,
                    start: "top " + (75 + 35 * i),
                    end: "bottom bottom",
                    endTrigger: ".container",
                    scrub: true,
                    pin: card,
                    pinSpacing: false,
                    invalidateOnRefresh: true,
                },
            });

            ScrollTrigger.create({
                trigger: card,
                start: "top 70%",
                once: true,
                onEnter: () => {
                    const tl = gsap.timeline();

                    tl.to(img, {
                        clipPath: "polygon(0 0, 0 100%, 100% 100%, 100% 0)",
                        autoAlpha: 1,
                        duration: 2,
                        delay: 0.2,
                        ease: "power2.out",
                    });

                    tl.to(
                        textEls, 
                        {
                        y: -10,
                        autoAlpha: 1,
                        duration: 0.6,
                        ease: "power2.out",
                        stagger: 0.4,
                        },
                        "-=1.5"
                    );
                },

            });
        });

    },
    {scope: containerRef}
    );



    return (
        <div ref={containerRef}> 
            <div className="spacer"></div>

            <div className="container">
                <div className="stacked-cards">
                    {cardsData.map((card, index) => (
                        <a
                            className="card"
                            key={index}
                            href={card.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                            <div className="card-content">
                                <h1>{card.title}</h1>
                                <p style={{ whiteSpace: 'pre-line', color: '#7484BE' }}>{card.language}</p>
                                <p style={{ whiteSpace: 'pre-line'}}>{card.description}</p>
                            </div>
                            <div className="img-wrapper">
                                <picture>
                                    <source srcSet={card.img} type="image/webp" />
                                    <img src={card.imgFallback} alt={card.title} loading="lazy" />
                                </picture>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </div>
    )
};  